// brandResolvers.ts

import type { BrandResolver } from "@/types/Portal.types";
import { Analytics, CloudQueue, Gavel, GppGood, TaskAlt, Quiz } from "@mui/icons-material";

export const ProfessionalBrandResolver: BrandResolver = (item) => {
  const name = item.quizName.toLowerCase();

  if (name.includes("hksile")) {
    return {
      icon: Gavel,
      accentColor: "#1e40af",
      gradient: "radial-gradient(circle at 90% 10%, rgba(30, 64, 175, 0.08) 0%, rgba(255,255,255,0) 60%)",
    };
  }
  if (name.includes("sfcaml")) {
    return {
      icon: GppGood,
      accentColor: "#059669",
      gradient: "radial-gradient(circle at 90% 10%, rgba(5, 150, 105, 0.08) 0%, rgba(255,255,255,0) 60%)",
    };
  }
  if (name.includes("frm")) {
    return {
      icon: Analytics,
      accentColor: "#dc2626",
      gradient: "radial-gradient(circle at 90% 10%, rgba(220, 38, 38, 0.06) 0%, rgba(255,255,255,0) 60%)",
    };
  }
  if (name.includes("aws")) {
    return {
      icon: CloudQueue,
      accentColor: "#f90",
      gradient: "radial-gradient(circle at 90% 10%, rgba(255, 153, 0, 0.08) 0%, rgba(255,255,255,0) 60%)",
    };
  }
  if (name.includes("pmp") || name.includes("capm")) {
    return {
      icon: TaskAlt,
      accentColor: "#2e7d32",
      gradient: "radial-gradient(circle at 90% 10%, rgba(46, 125, 50, 0.07) 0%, rgba(255,255,255,0) 60%)",
    };
  }
  return {
    icon: Quiz,
    accentColor: "#64748b",
    gradient: "radial-gradient(circle at 90% 10%, rgba(100, 116, 139, 0.05) 0%, rgba(255,255,255,0) 60%)",
  };
};
